// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3XGuU","file":"styles_file__3N1t1"};